import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { CompanyUserModel } from '@ninety/mobile/platform/api';

import { CompanyUserListModel } from './company-users-state.model';

export const CompanyUsersStateActions = createActionGroup({
  source: 'Company Users',
  events: {
    Fetch: emptyProps(),
    'Fetch Success': props<{ companyUsers: CompanyUserModel[] }>(),
    'Fetch Error': props<{ error: unknown }>(),
    'Set Company Users': props<{ companyUsers: CompanyUserListModel[] }>(),
    'After Company Users Loaded': emptyProps(),
    'App Logout': emptyProps(),
  },
});
